import { useEffect, useState } from 'react';
import PageTemplate from 'components/template/PageTemplate';
import Container from 'components/common/Container';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomInput from 'components/common/CustomInput';
import CustomButton from 'components/common/CustomButton';
import { toast } from 'react-toastify';
import { jsonAxios } from 'components/axios';
import CustomSelect from 'components/common/CustomSelect';
import { activeSelect } from 'data/quote';
import Bg1 from 'assets/mypage/Sub/sub.avif'

const SubAccountModify = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { item } = location.state || {};

    const [signUpInfo, setSignUpInfo] = useState({
        email: '',
        password: '',
        isActive: true
    })

    useEffect(() => {
        if (item) {
            setSignUpInfo(p => ({
                ...p,
                email: item.username,
                isActive: item.isActive
            }))
        }
        else {
            toast.error('올바르지 않는 정보입니다.')
            setTimeout(() => {
                navigate(-1)
            }, 400)
        }
    }, [item])

    const changeStatus = () => {
        jsonAxios.post('sub-users', { userId: item.id }).then(res => {
            if (res.data.code === 200) {
                toast.success('정상적으로 상태를 변경했습니다.')
            }
            else {
                toast.error('상태를 변경하지 못했습니다. 관리자에게 문의해주세요.')
            }
        })
    }

    return (
        <PageTemplate background='bg-[#F8F8FA]'>
            <div
                className="relative flex justify-center items-center bg-primary bg-cover h-60 mobile:h-30 text-white"
                style={{
                    backgroundPosition: "center",
                    backgroundImage: `url(${Bg1})`,
                }}
            >
                <div className='z-10 relative flex flex-col justify-center items-center gap-2'>
                    <p className='font-semibold text-32 tablet:text-2xl'>서브계정 수정</p>
                </div>
            </div>
            <Container className="mb-6 py-10 tablet:pt-4 h-full">
                <div className='flex flex-col justify-between bg-white mx-auto mb-10 p-10 tablet:p-4 rounded-lg max-w-[512px] min-h-[680px] tablet:min-h-0'>
                    <div className='flex flex-col gap-6'>
                        <div className='flex flex-col gap-3'>
                            <p className='font-semibold mobile:text-base text-lg'>
                                이메일
                            </p>
                            <CustomInput
                                type={'email'}
                                disabled
                                value={signUpInfo.email}
                                autocompleteOff
                                placeholder={'아이디로 사용할 이메일을 등록해주세요'}
                                onChange={() => { }}
                            />
                        </div>

                        <div className='flex flex-col gap-3'>
                            <div>
                                <p className='font-semibold mobile:text-base text-lg'>
                                    비밀번호<span className='text-red'> *</span>
                                </p>
                            </div>
                            <div>
                                <CustomButton
                                    className='bg-primary w-full'
                                    title='비밀번호 재설정'
                                    onClick={() => {
                                        navigate('/mypage/subAccount/modify/reset', { state: { item } })
                                    }}
                                />
                            </div>
                        </div>

                        <div className='flex flex-col gap-3'>
                            <p className='font-semibold mobile:text-base text-lg'>
                                상태
                            </p>
                            <CustomSelect
                                height={60}
                                fontSize={18}
                                option={activeSelect}
                                value={
                                    signUpInfo.isActive !== undefined
                                        ? activeSelect.find(arr => arr.value === (signUpInfo.isActive ? 'Y' : 'N'))
                                        : undefined
                                }
                                placeholder={'사용여부'}
                                onChange={(value) => {
                                    setSignUpInfo(p => ({
                                        ...p,
                                        isActive: value === 'Y' ? true : false
                                    }))
                                    changeStatus();
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Container>
        </PageTemplate>
    )
}

export default SubAccountModify